import { render, staticRenderFns } from "./CompanyBrief.vue?vue&type=template&id=4bab7ef8&scoped=true&"
import script from "./CompanyBrief.vue?vue&type=script&lang=js&"
export * from "./CompanyBrief.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBrief.vue?vue&type=style&index=0&id=4bab7ef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bab7ef8",
  null
  
)

export default component.exports